module.exports = __webpack_public_path__ + "static/img/news1.08571cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/news1.png
// module id = UpjH
// module chunks = 11